import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { FilterExpand } from "@circle-react-shared/Filter";
import { FiltersList } from "@circle-react-shared/Filter/FiltersList";
import type { FilterType } from "../types";

export interface FilterOption {
  label: string;
  value: FilterType;
}

export interface CourseFiltersProps {
  filter: FilterType;
  onClickHandler: (value: FilterType) => void;
}

export const CourseFilters = ({
  filter,
  onClickHandler,
}: CourseFiltersProps) => {
  const filterOptions: FilterOption[] = [
    { value: "all", label: t("courses.directory.filters.all_courses") },
    { value: "joined", label: t("courses.directory.filters.my_courses") },
  ];

  return (
    <FiltersList
      className={classNames(
        "bg-primary border-primary border-b px-6 py-3 lg:px-9",
      )}
    >
      <FilterExpand
        selectedText={filter}
        options={filterOptions}
        label={t("courses.directory.filters.header")}
        onChange={onClickHandler}
      />
    </FiltersList>
  );
};
